import { api, ApiError } from "./api.js";
import { toast } from "./utils.js";

/**
 * The follow switch on a dive site's or a cohort's page: following brings
 * what's posted about it into the Following feed.
 *
 * Rendered only when the API said whether the viewer follows it, which it
 * does for signed-in viewers only. `following` is that answer.
 */
export function followSwitchHtml({ following, label, help }) {
  if (typeof following !== "boolean") return "";
  return `
    <div class="form-check form-switch mt-3 mb-0">
      <input class="form-check-input" type="checkbox" role="switch" id="follow-switch"
        ${following ? "checked" : ""} />
      <label class="form-check-label" for="follow-switch">${label}</label>
    </div>
    <div class="form-text mt-0">${help}</div>`;
}

/** Follows or unfollows (POST `${path}/follow` or `/unfollow`) as the switch
 *  is flipped, and puts it back if that fails. `onChange` gets the API's
 *  answer, for a page that keeps its own copy. */
export function attachFollowSwitch(container, { path, onChange = () => {} }) {
  const toggle = container.querySelector("#follow-switch");
  if (!toggle) return;
  toggle.addEventListener("change", async () => {
    const follow = toggle.checked;
    toggle.disabled = true;
    try {
      const updated = await api.post(`${path}/${follow ? "follow" : "unfollow"}`);
      toggle.checked = updated.is_following === true;
      onChange(updated);
    } catch (err) {
      toggle.checked = !follow;
      // An unconfirmed email already has its own dialog (api.js).
      if (!(err instanceof ApiError && err.code === "email_not_verified")) {
        toast(err instanceof ApiError ? err.message : "Could not update that follow.", "danger");
      }
    } finally {
      toggle.disabled = false;
    }
  });
}
